var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSuccess1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "72px",
    height: "72px",
    viewBox: "0 0 72 72",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "3EDC9E9B-AA8E-4CB9-9D90-D7CC5E3BAA0C") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "11-12-13-Subscribe/payment/subscriptions",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Payment-12_152-payment-success",
    transform: "translate(-684.000000, -404.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Welcome-Back",
    transform: "translate(495.000000, 368.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic_success",
    transform: "translate(189.000000, 36.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse",
    fill: "#F5F5F5",
    cx: 36,
    cy: 36,
    r: 36
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26,37.4 L30.743,41.02 L38.359,32.316 L36.853,31 L30.469,38.296 L27.212,35.81 L26,37.4 Z M45.359,32.316 L43.853,31 L37.484,38.279 L36.731,37.677 L35.481,39.239 L37.728,41.037 L45.359,32.316 Z",
    fill: "#2F665C",
    fillRule: "nonzero"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSuccess1);
export default __webpack_public_path__ + "static/media/ic-success (1).2ea79dd91cb212b120ab43e57b73ae75.svg";
export { ForwardRef as ReactComponent };